module.exports = __webpack_public_path__ + "media/images/emoticons/sign03-5afe6ca63827f4b87c2366489eeffc01.gif";